import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetEventsPath } from '#/modules/search/events/routing/searchGetEventsPath';
import { searchGetVolopsPath } from '#/modules/search/volops/routing/searchGetVolopsPath';

import type { VolunteerDropdownData } from './types/VolunteerDropdownData';

export const volunteerDropdownDataPt: VolunteerDropdownData = {
  search: {
    title: 'Busca',
    items: [
      {
        type: 'volop',
        title: 'Voluntariado',
        href: searchGetVolopsPath({
          locale: I18nLocale.PT,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'event',
        title: 'Eventos',
        href: searchGetEventsPath({ locale: I18nLocale.PT }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [],
  },
};
